export enum ApiErrors {
  NoResponseData = "NO RESPONSE DATA",
}
